import { Component, OnInit } from '@angular/core';
import { Question, QuestionsLabels, QuestionType } from '../../student/test.model';
import { FileUploadService } from '../../shared/components/edit-question-block/file-upload.service';
import { forkJoin, Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'curr-tutorial-session-question',
  templateUrl: './tutorial-session-question.component.html',
  styleUrls: ['./tutorial-session-question.component.scss']
})
export class TutorialSessionQuestionComponent implements OnInit {
  questionType = QuestionType;
  isCtTest: boolean;
  // @ts-ignore
  ctItem: any;
  questionsLabels = QuestionsLabels;
  //   {
  //   answer_file: "",
  //   answer_options: ['first', 'second', 'last one', 'Unsure of the Answer'],
  //   answer_text: null,
  //   answer_type: 'MULTI_CHOICE',
  //   audio_answer: null,
  //   correct_answer_options: [2],
  //   cou_right: null,
  //   cou_wrong: null,
  //   curriculum_lobjective_id: 3912,
  //   hint: 'Test hint',
  //   is_correct: null,
  //   is_past_exam_question: false,
  //   lobj_sa_questionId: 3272,
  //   question: "<p>The diagram shows the reading on an analogue ammeter.</p>\n<p><img src=\"50065a23-bc17-4054-88ba-53668e26bae6.png\" /></p>\n<p>Which digital ammeter reading is the same as the reading on the analogue ammeter?</p>\n<p><img src=\"d39bbd81-9bdb-4ac3-bf70-f2f407fb682f.png\" /></p>",
  //   question_file: "",
  //   resource_ids: null,
  //   response_type: "LOR",
  //   result_mark: null,
  //   student_answer_file: null,
  //   student_answer_text: null,
  //   student_correct_answer_options: [1],
  //   student_cou_right: null,
  //   student_cou_wrong: null,
  //   student_sa_test_id: 2181,
  //   student_sa_test_question_id: 10566,
  //   text_answer: null,
  //   video_url: "<p><span class=\"TextRun SCXW218658616 BCX0\" lang=\"EN-GB\" xml:lang=\"EN-GB\" data-contrast=\"none\"><span class=\"NormalTextRun SCXW218658616 BCX0\">Halve the coefficient of x to give"
  // }
  isLoading: boolean;

  constructor(private fileUploadService: FileUploadService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.ctItem = this.route.snapshot.data.TutorialSessionQuestionResolver.data.question;
    this.isCtTest = this.route.snapshot.data.TutorialSessionQuestionResolver.data.questionType === 'TOPIC_TEST_QUESTION';
    this.getQuestionDescription();
  }

  isMultiVariants(question: any): boolean {
    return (
      question.answer_type === 'MULTI_CHOICE' ||
      question.answer_type === 'TRUE_FALSE' ||
      question.answer_type === 'MULTI_SELECT'
    );
  }

  isOpenAnswer() {
    return (
      this.ctItem.answerType === this.questionType.SELECT_ONE ||
      this.ctItem.answerType === this.questionType.SELECT_MULTIPLE ||
      this.ctItem.answerType === this.questionType.TRUE_OR_FALSE
    );
  }

  getQuestionDescription() {
    if (this.ctItem.question.includes('<img src')) {
      const imageKeyValue = this.fileUploadService.getAllImageKeysFromNote(this.ctItem.question);
      this.uploadImages(imageKeyValue, this.ctItem);
    }
    return this.ctItem.question;
  }

  private async uploadImages(imageKeyValue: any, q: Question) {
    this.isLoading = true;
    let previewQuestion = q.question;

    const observersObj: { [key: string]: Observable<any> } = {};

    for (const key of Object.keys(imageKeyValue)) {
      observersObj[key] = this.fileUploadService.download(key, 'IMAGE');
    }

    forkJoin(observersObj).subscribe({
      next: (res: any) => {
        for (const [key, value] of Object.entries(res)) {
          const bytes = (value as any)?.data?.bytes;
          imageKeyValue[key] = 'data:image/png;base64,' + bytes;
          previewQuestion = previewQuestion.replace(key, imageKeyValue[key]);
        }
      },
      complete: () => {
        this.isLoading = false;
        q.previewQuestion = previewQuestion;
      }
    });
  }
}
